// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import PasswordGeneratorController from "./password_generator_controller"
application.register("password-generator", PasswordGeneratorController)

// import DatepickerController from "./datepicker_controller"
// application.register("datepicker", DatepickerController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import LessonFormController from "./lesson_form_controller"
application.register("lesson-form", LessonFormController)

import StudentMenuController from "./student_menu_controller"
application.register("student-menu", StudentMenuController)

import AdminMenuController from "./admin_menu_controller"
application.register("admin-menu", AdminMenuController)

import TagInserterController from "./tag_inserter_controller"
application.register("tag-inserter", TagInserterController)

import AttestationStatusController from "./attestation_status_controller"
application.register("attestation-status", AttestationStatusController)

import KbStatusController from "./kb_status_controller"
application.register("kb-status", KbStatusController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import AttestationResultsController from "./attestation_results_controller"
application.register("attestation-results", AttestationResultsController)

import CuratorCommentController from "./curator_comment_controller"
application.register("curator-comment", CuratorCommentController)

import ApiKeyFormController from "./api_key_form_controller"
application.register("api-key-form", ApiKeyFormController)

import SwaggerUiController from "./swagger_ui_controller"
application.register("swagger-ui", SwaggerUiController)
